export const AssessmentModeEnum = {
    STANDARD: 'standard',
    STUDENT: 'student',
};